import { useEffect, useState } from "react";
import { api } from "../lib/api";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { DestinationCard } from "../components/ContentCards";

export default function DestinationsPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/destinations?status=published&limit=50").then((r) => setItems(r.data.items)); }, []);
  return (
    <div className="min-h-screen bg-[#F9F9F6]">
      <Header />
      <div className="container-page py-12 md:py-20">
        <div className="overline text-[#B4533C]">Destination Guides</div>
        <h1 className="font-serif text-5xl md:text-6xl tracking-tight mt-2">Where to go, and how to get there smart</h1>
      </div>
      <div className="container-page pb-20 grid md:grid-cols-3 gap-5">
        {items.map((d) => <DestinationCard key={d.id} dest={d} />)}
      </div>
      <Footer />
    </div>
  );
}
